import { Location, useLocation as _useLocation } from 'react-router-dom';
export const useLocation = <T = never>() => _useLocation() as Location<T | null>;
